import { makeAutoObservable } from 'mobx';
import type { DesktopUpdateState } from './skjv-desktop';

/**
 * Observable mirror of the shell updater's state, driving the persistent
 * update toast (download progress → restart prompt). Fed by
 * useDesktopUpdates; the shell remains the source of truth.
 */
class DesktopUpdateStore {
  state: DesktopUpdateState | null = null;
  dismissed = false;

  constructor() {
    makeAutoObservable(this);
  }

  setState(state: DesktopUpdateState): void {
    // A phase change resurfaces a toast the member dismissed earlier.
    if (this.state?.phase !== state.phase) this.dismissed = false;
    this.state = state;
  }

  dismiss(): void {
    this.dismissed = true;
  }
}

export const desktopUpdateStore = new DesktopUpdateStore();
